import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { RootState } from '../../../../ducks/store';
import { Timezone } from '../../../../utils/constants';
import { updateLoadDate } from '../../../../ducks/report';

export const formateDateTime = (date: Date) => {
  const options: Intl.DateTimeFormatOptions = {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  };

  return date.toLocaleString('en-US', options).replace(',', ' at');
};

const LoadDateTime = () => {
  const dispatch = useDispatch();

  const { activeTeams, activeDeselectedCourses, loadDate } = useSelector((state: RootState) => ({
    activeTeams: state.teamsSlice.activeTeams,
    activeDeselectedCourses: state.teamsSlice.activeDeselectedCourses,
    loadDate: new Date(state.report.loadDate),
  }));

  useEffect(() => {
    const now = new Date();
    dispatch(updateLoadDate(now));
  }, [dispatch, activeTeams, activeDeselectedCourses]);

  return (
    <p>
      as of {formateDateTime(loadDate)} ({Timezone})
    </p>
  );
};

export default LoadDateTime;
